/* SOLEN — gift-option.js
   Gift option in the cart drawer: free (wrap + outside sticker) or +€3.99 (adds
   personalised card inside). Messages stored as cart attributes; the paid option
   adds/removes the hidden gift-wrapping product. */
(function () {
  'use strict';

  var box = null;
  var VARIANT = 0;

  function $(sel, root) { return (root || document).querySelector(sel); }

  function getBox() {
    box = $('[data-gift]');
    if (box) VARIANT = parseInt(box.getAttribute('data-gift-variant'), 10);
    return box;
  }

  function cartFetch() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function post(payload) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.json(); });
  }

  function refreshDrawer() {
    if (window.SolenCart && window.SolenCart.refresh) window.SolenCart.refresh();
  }

  function sync() {
    if (!getBox()) return;
    cartFetch().then(function (cart) {
      var wrap = null;
      var real = 0;
      cart.items.forEach(function (i) {
        if (i.variant_id === VARIANT) { wrap = i; } else { real++; }
      });

      if (!real) {
        box.hidden = true;
        if (wrap) {
          var u0 = {}; u0[VARIANT] = 0;
          post({ updates: u0 }).then(refreshDrawer);
        }
        return;
      }

      box.hidden = false;
      var attrs = cart.attributes || {};
      var paid = !!wrap;
      var on = attrs['Gift'] === 'yes' || paid;

      if (paid && attrs['Gift'] !== 'yes') {
        post({ attributes: { 'Gift': 'yes', 'Gift option': 'personalised card (+€3.99)' } });
      }

      var check = $('[data-gift-check]', box);
      var body = $('[data-gift-body]', box);
      if (check) check.checked = on;
      if (body) body.hidden = !on;

      var rp = box.querySelector('[data-gift-type][value="paid"]');
      var rf = box.querySelector('[data-gift-type][value="free"]');
      if (rp) rp.checked = paid;
      if (rf) rf.checked = !paid;

      var msgWrap = $('[data-gift-msg-wrap]', box);
      if (msgWrap) msgWrap.hidden = !(on && paid);
      var msg = $('[data-gift-msg]', box);
      if (msg && document.activeElement !== msg) msg.value = attrs['Gift card message (inside)'] || '';
      var st = $('[data-gift-sticker]', box);
      if (st && document.activeElement !== st) st.value = attrs['Gift sticker (outside)'] || '';

      if (wrap && wrap.quantity !== 1) {
        var u1 = {}; u1[VARIANT] = 1;
        post({ updates: u1 }).then(refreshDrawer);
      }
    }).catch(function () {});
  }

  document.addEventListener('change', function (e) {
    if (!box) return;
    var t = e.target;
    if (t.matches && t.matches('[data-gift-check]')) {
      var body = $('[data-gift-body]', box);
      if (t.checked) {
        if (body) body.hidden = false;
        post({ attributes: { 'Gift': 'yes', 'Gift option': 'free — wrap + outside sticker' } });
      } else {
        if (body) body.hidden = true;
        var u = {}; u[VARIANT] = 0;
        post({
          updates: u,
          attributes: { 'Gift': '', 'Gift option': '', 'Gift sticker (outside)': '', 'Gift card message (inside)': '' }
        }).then(function () { refreshDrawer(); sync(); });
      }
    } else if (t.matches && t.matches('[data-gift-type]') && t.checked) {
      var mw = $('[data-gift-msg-wrap]', box);
      if (mw) mw.hidden = (t.value !== 'paid');
      var u2 = {};
      if (t.value === 'paid') {
        u2[VARIANT] = 1;
        post({ updates: u2, attributes: { 'Gift': 'yes', 'Gift option': 'personalised card (+€3.99)' } })
          .then(function () { refreshDrawer(); sync(); });
      } else {
        u2[VARIANT] = 0;
        post({ updates: u2, attributes: { 'Gift': 'yes', 'Gift option': 'free — wrap + outside sticker', 'Gift card message (inside)': '' } })
          .then(function () { refreshDrawer(); sync(); });
      }
    }
  });

  var dt;
  document.addEventListener('input', function (e) {
    if (!box) return;
    var t = e.target;
    if (!t.matches) return;
    var isSticker = t.matches('[data-gift-sticker]');
    var isMsg = t.matches('[data-gift-msg]');
    if (!isSticker && !isMsg) return;
    clearTimeout(dt);
    var key = isSticker ? 'Gift sticker (outside)' : 'Gift card message (inside)';
    var val = t.value;
    dt = setTimeout(function () {
      var a = {}; a[key] = val.trim();
      post({ attributes: a });
    }, 600);
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-cart-open]')) setTimeout(sync, 400);
  });

  function watch() {
    var items = $('[data-cart-items]');
    if (!items || !window.MutationObserver) return;
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(sync, 250);
    }).observe(items, { childList: true, subtree: true });
  }

  function init() { getBox(); sync(); watch(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
